"use client";

import { motion } from "framer-motion";
import { Droplet, Store } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
const collaborationsData = [{
  icon: Droplet,
  title: "Acquaviva SpA",
  date: "2023 - 2026",
  description: "Brand strategy, content marketing e presenza digitale per il leader italiano nei distributori d'acqua.",
  colSpan: "md:col-span-7"
}, {
  icon: Store,
  title: "Venditalia",
  date: "2024",
  description: "Strategia di comunicazione e materiali per la fiera internazionale del vending.",
  colSpan: "md:col-span-5"
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};
export default function Collaborations() {
  return <section id="collaborations" className="bg-background py-24 overflow-hidden">
      
    </section>;
}